import React, { PropsWithChildren, useEffect, useState } from 'react';
import { loadRemotes } from 'mfe/manifest';
import { RemotesContext, RemotesState } from 'mfe/remotesContext';

function RemotesProvider({ children }: PropsWithChildren<unknown>) {
  const [state, setState] = useState<RemotesState>({ status: 'loading', remotes: [] });

  useEffect(() => {
    let cancelled = false;
    loadRemotes()
      .then(remotes => {
        if (!cancelled) setState({ status: 'ready', remotes });
      })
      .catch((error: unknown) => {
        // Manifeste absent, invalide ou fetch impossible : l'app tourne sans remote.
        console.warn('[MFE] Chargement du manifeste impossible, aucun remote monté :', error);
        if (!cancelled) setState({ status: 'error', remotes: [] });
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return <RemotesContext.Provider value={state}>{children}</RemotesContext.Provider>;
}

export default RemotesProvider;
